exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".typeCounter--container[data-v-0af2e020]{position:absolute;padding:0;right:0;top:0;border-top-right-radius:4px;border-bottom-right-radius:4px;background:#f5f5f5;margin:1px}.typeCounter--circle[data-v-0af2e020]{fill-opacity:0}.typeCounter--circle .typeCounter--innerCircle[data-v-0af2e020]{border-radius:100px;height:20px;width:20px;font-size:12px;box-sizing:border-box}.typeCounter--circle[data-v-0af2e020],.typeCounter--innerCircle[data-v-0af2e020],svg[data-v-0af2e020]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);

// exports
